import React, { useState } from 'react';
import { motion } from 'framer-motion';
import bananaImg from '../Assets/Images/banana-2828905.jpg';

/* ---------- Inline SVG icons (no external deps) ---------- */
const LeafIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M17 8C8 10 5.9 16.17 3.82 21.34l1.89.66.95-2.3c.48.17.98.3 1.34.3C19 20 22 3 22 3c-1 2-8 2.25-13 3.25S2 11.5 2 13.5s1.75 3.75 1.75 3.75S3.5 8 17 8z" />
  </svg>
);
const DropIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M12 2.5S5.5 9.5 5.5 14.5a6.5 6.5 0 0 0 13 0C18.5 9.5 12 2.5 12 2.5z" />
  </svg>
);
const WrenchIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z" />
  </svg>
);
const DocIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
  </svg>
);
const CalcIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="5" y="2.5" width="14" height="19" rx="2.5" />
    <rect x="8" y="5.5" width="8" height="3" />
    <circle cx="9" cy="13" r="0.7" fill="currentColor" stroke="none" />
    <circle cx="12" cy="13" r="0.7" fill="currentColor" stroke="none" />
    <circle cx="15" cy="13" r="0.7" fill="currentColor" stroke="none" />
    <circle cx="9" cy="17" r="0.7" fill="currentColor" stroke="none" />
    <circle cx="12" cy="17" r="0.7" fill="currentColor" stroke="none" />
    <circle cx="15" cy="17" r="0.7" fill="currentColor" stroke="none" />
  </svg>
);
const SproutIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 22v-9" />
    <path d="M12 13C12 9 9 6.5 4.5 6.5 4.5 10.5 7.5 13 12 13z" />
    <path d="M12 13c0-3.2 2.6-5.5 6.5-5.5C18.5 10.7 15.9 13 12 13z" />
  </svg>
);
const ScaleIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 3v18" />
    <path d="M7 21h10" />
    <path d="M5 7h14" />
    <path d="M5 7l-2.5 5a2.5 2.5 0 0 0 5 0L5 7z" />
    <path d="M19 7l-2.5 5a2.5 2.5 0 0 0 5 0L19 7z" />
    <circle cx="12" cy="5" r="1.2" fill="currentColor" stroke="none" />
  </svg>
);
const BoxIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3z" />
    <path d="M4 7.5l8 4.5 8-4.5" />
    <path d="M12 12v9" />
  </svg>
);
const InfoIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <circle cx="12" cy="12" r="10" />
    <rect x="11" y="10.5" width="2" height="6.5" rx="1" fill="#fff" />
    <circle cx="12" cy="7.6" r="1.3" fill="#fff" />
  </svg>
);
const CheckCircle = (props) => (
  <svg viewBox="0 0 24 24" {...props}>
    <circle cx="12" cy="12" r="10" fill="#16a34a" />
    <path d="M8 12.4l2.6 2.6 5-5.6" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
const BarsIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <rect x="4" y="12" width="4" height="8" rx="1" />
    <rect x="10" y="8" width="4" height="12" rx="1" />
    <rect x="16" y="4" width="4" height="16" rx="1" />
  </svg>
);
const ShieldPercent = (props) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M12 2l7 2.5v6c0 4.6-3 8.3-7 9.8-4-1.5-7-5.2-7-9.8v-6L12 2z" fill="currentColor" />
    <line x1="14.5" y1="8.5" x2="9.5" y2="15" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" />
    <circle cx="9.6" cy="9.2" r="1.1" fill="#fff" />
    <circle cx="14.4" cy="14.6" r="1.1" fill="#fff" />
  </svg>
);
const FarmScene = (props) => (
  <svg viewBox="0 0 200 80" fill="none" {...props}>
    <path d="M0 60 Q50 42 100 55 T200 50 V80 H0 Z" fill="#bbf7d0" />
    <path d="M0 70 Q60 56 120 68 T200 62 V80 H0 Z" fill="#86efac" />
    <g fill="#16a34a">
      <circle cx="152" cy="52" r="8" />
      <rect x="151" y="52" width="2" height="11" />
      <circle cx="170" cy="56" r="6" />
      <rect x="169" y="56" width="2" height="8" />
    </g>
    <rect x="120" y="49" width="15" height="13" fill="#4ade80" />
    <path d="M118 49 L127.5 41 L137 49 Z" fill="#16a34a" />
  </svg>
);

/* ---------- Data (unchanged values / functionality) ---------- */
const contributionItems = [
  { label: 'Lease amount', amount: '45,000', percent: 18, Icon: DocIcon, tint: 'bg-amber-50 text-amber-500' },
  { label: 'Saplings & infrastructure', amount: '90,000', percent: 36, Icon: LeafIcon, tint: 'bg-green-50 text-green-600' },
  { label: 'Manure, nutrients & labour', amount: '90,000', percent: 36, Icon: DropIcon, tint: 'bg-sky-50 text-sky-500' },
  { label: 'Maintenance & miscellaneous', amount: '25,000', percent: 10, Icon: WrenchIcon, tint: 'bg-violet-50 text-violet-500' },
];

const yieldStats = [
  { Icon: SproutIcon, label: 'Plants', value: '1,000', sub: 'productive' },
  { Icon: ScaleIcon, label: 'Yield / plant', value: '10 kg', sub: 'avg per cycle' },
  { Icon: BoxIcon, label: 'Total yield', value: '10,000 kg', sub: 'per acre / cycle' },
];

const scenarios = [
  {
    key: 'conservative',
    label: 'Conservative',
    pricePerKg: 35,
    grossRevenue: '3,50,000',
    productionCost: '2,50,000',
    netProceeds: '1,00,000',
    cycle1: { revenue: '3,50,000', yourShare: '50,000' },
    cycle23: { revenue: '3,50,000', netShare: '95,000', label: 'Net ₹1,90,000 → Your 50%: ₹95,000' },
    totalShare: '2,40,000',
    totalPercent: '~96% of contribution',
  },
  {
    key: 'moderate',
    label: 'Moderate',
    pricePerKg: 45,
    grossRevenue: '4,50,000',
    productionCost: '2,50,000',
    netProceeds: '2,00,000',
    cycle1: { revenue: '4,50,000', yourShare: '1,00,000' },
    cycle23: { revenue: '4,50,000', netShare: '1,45,000', label: 'Net ₹2,90,000 → Your 50%: ₹1,45,000' },
    totalShare: '3,90,000',
    totalPercent: '~156% of contribution',
  },
  {
    key: 'bestcase',
    label: 'Best Case',
    pricePerKg: 65,
    grossRevenue: '6,50,000',
    productionCost: '2,50,000',
    netProceeds: '4,00,000',
    cycle1: { revenue: '6,50,000', yourShare: '2,00,000' },
    cycle23: { revenue: '6,50,000', netShare: '2,45,000', label: 'Net ₹4,90,000 → Your 50%: ₹2,45,000' },
    totalShare: '6,90,000',
    totalPercent: '~276% of contribution',
  },
];

/* ---------- Reusable card header with green square number badge ---------- */
const NumberBadge = ({ n }) => (
  <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-gradient-to-br from-green-600 to-[rgb(2,58,16)] text-white flex items-center justify-center text-sm font-bold shadow-sm">
    {n}
  </span>
);

const cardClass =
  'bg-white rounded-2xl border border-green-100/80 shadow-[0_12px_40px_-18px_rgba(2,58,16,0.28)] hover:shadow-[0_24px_55px_-20px_rgba(2,58,16,0.38)] transition-shadow duration-300 overflow-hidden';

const Economics = () => {
  const [activeScenario, setActiveScenario] = useState('moderate');

  const current = scenarios.find((s) => s.key === activeScenario);

  return (
    <section
      className="relative py-16 md:py-24 bg-gradient-to-b from-white via-green-50/50 to-white overflow-hidden"
      id="economics"
    >
      {/* Decorative background glow */}
      <div className="pointer-events-none absolute -top-10 -left-24 w-72 h-72 bg-green-200/30 rounded-full blur-3xl" />
      <div className="pointer-events-none absolute bottom-32 -right-24 w-80 h-80 bg-emerald-200/30 rounded-full blur-3xl" />

      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header with banana imagery */}
        <div className="relative max-w-4xl mx-auto mb-8">
          <img
            src={bananaImg}
            alt=""
            aria-hidden="true"
            className="hidden md:block absolute -top-4 right-0 w-[38%] h-[210px] object-cover select-none pointer-events-none rounded-bl-[3rem]"
            style={{
              WebkitMaskImage: 'radial-gradient(135% 135% at 100% 0%, #000 38%, transparent 74%)',
              maskImage: 'radial-gradient(135% 135% at 100% 0%, #000 38%, transparent 74%)',
            }}
          />
          <motion.div
            className="relative z-10 md:max-w-[60%]"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <div className="flex items-center gap-3 mb-4">
              <span className="flex-shrink-0 w-11 h-11 rounded-full bg-green-100 flex items-center justify-center text-green-600">
                <LeafIcon className="w-6 h-6" />
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-[rgb(2,58,16)] leading-tight">
                Farming Partnership Economics
              </h2>
            </div>
            <p className="text-base text-gray-700 font-serif leading-relaxed">
              Every farming cycle involves input costs (land prep, irrigation, inputs, labour, AI-based
              monitoring) and harvest proceeds. After operational costs, net proceeds are shared
              between Kiaan Agrowtech and farming partners based on their share in the cycle.
            </p>
          </motion.div>
        </div>

        {/* Illustrative Example Note */}
        <motion.div
          className="max-w-4xl mx-auto mb-10 bg-green-50/70 border border-green-100 rounded-xl px-5 py-4 flex items-start gap-3"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          viewport={{ once: true }}
        >
          <span className="flex-shrink-0 mt-0.5 w-7 h-7 rounded-full bg-green-100 flex items-center justify-center text-green-600">
            <InfoIcon className="w-5 h-5" />
          </span>
          <div>
            <p className="text-sm md:text-base font-semibold text-gray-800">
              Illustrative example{' '}
              <span className="font-normal text-gray-500">(based on past cycles):</span>
            </p>
            <p className="text-xs md:text-sm text-gray-500 font-serif italic mt-1">
              Note: Actual proceeds depend on yield, market prices, and farm performance. This is
              agricultural produce — subject to natural variability, not guaranteed financial returns.
            </p>
          </div>
        </motion.div>

        <div className="max-w-4xl mx-auto space-y-6">
          {/* 1. Partnership Contribution */}
          <motion.div
            className={cardClass}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            {/* Header row: badge + title/subtitle + calculator icon */}
            <div className="flex items-start gap-3 px-6 md:px-8 pt-6">
              <NumberBadge n="1" />
              <div className="flex-1">
                <h3 className="text-lg md:text-xl font-bold text-[rgb(2,58,16)]">
                  Yelakki — 1 acre · 1,000 plants
                </h3>
                <p className="text-sm text-gray-500 font-serif">Kiaan Agrowtech farming partnership</p>
              </div>
              <span className="flex-shrink-0 w-11 h-11 rounded-xl bg-green-50 flex items-center justify-center text-green-600">
                <CalcIcon className="w-6 h-6" />
              </span>
            </div>

            <div className="px-6 md:px-8 pt-5 pb-2">
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wider">
                Partnership Contribution
              </p>
            </div>

            {/* Cost Items */}
            <div className="px-6 md:px-8 pb-6">
              <div className="space-y-4">
                {contributionItems.map((item, index) => {
                  const RowIcon = item.Icon;
                  return (
                    <div key={index} className="flex items-center gap-3">
                      <span className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center ${item.tint}`}>
                        <RowIcon className="w-5 h-5" />
                      </span>
                      <div className="flex-1">
                        <div className="flex items-center justify-between mb-1.5">
                          <span className="text-sm text-gray-700 font-serif">
                            {item.label}{' '}
                            <span className="text-gray-400 text-xs">· {item.percent}%</span>
                          </span>
                          <span className="text-sm font-bold text-[rgb(2,58,16)]">
                            {'₹'}{item.amount}
                          </span>
                        </div>
                        <div className="w-full bg-gray-100 rounded-full h-2.5">
                          <motion.div
                            className="h-2.5 rounded-full bg-gradient-to-r from-green-400 to-green-600"
                            initial={{ width: 0 }}
                            whileInView={{ width: `${item.percent}%` }}
                            transition={{ duration: 0.6, delay: index * 0.1 }}
                            viewport={{ once: true }}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Total */}
              <div className="flex items-center justify-between mt-6 bg-gradient-to-r from-green-50 to-emerald-50 border border-green-100 rounded-xl px-5 py-4">
                <span className="text-base font-bold text-[rgb(2,58,16)]">
                  Total contribution — 1 acre
                </span>
                <span className="text-xl font-bold text-[rgb(2,58,16)]">{'₹'}2,50,000</span>
              </div>
            </div>
          </motion.div>

          {/* 2. Yield Snapshot */}
          <motion.div
            className={cardClass}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <div className="flex items-center gap-3 px-6 md:px-8 pt-6 pb-4">
              <NumberBadge n="2" />
              <h3 className="text-lg md:text-xl font-bold text-[rgb(2,58,16)]">Yield Snapshot — Yelakki</h3>
            </div>
            <div className="px-6 md:px-8 pb-6">
              <div className="grid grid-cols-3 rounded-xl bg-green-50/40 border border-green-100">
                {yieldStats.map((stat, index) => {
                  const StatIcon = stat.Icon;
                  return (
                    <motion.div
                      key={index}
                      className={`flex flex-col sm:flex-row items-center gap-2 sm:gap-3 text-center sm:text-left px-3 py-5 ${
                        index > 0 ? 'border-l border-green-100' : ''
                      }`}
                      initial={{ opacity: 0, scale: 0.9 }}
                      whileInView={{ opacity: 1, scale: 1 }}
                      transition={{ duration: 0.4, delay: index * 0.1 }}
                      viewport={{ once: true }}
                    >
                      <span className="flex-shrink-0 w-12 h-12 rounded-full bg-green-100 flex items-center justify-center text-green-600">
                        <StatIcon className="w-6 h-6" />
                      </span>
                      <div>
                        <div className="text-xs text-gray-500 font-serif">{stat.label}</div>
                        <div className="text-lg md:text-2xl font-bold text-[rgb(2,58,16)] leading-tight">
                          {stat.value}
                        </div>
                        <div className="text-xs text-gray-400 font-serif">{stat.sub}</div>
                      </div>
                    </motion.div>
                  );
                })}
              </div>
            </div>
          </motion.div>

          {/* 3. Revenue and Your Share — Tap Scenario */}
          <motion.div
            className={cardClass}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="flex items-center gap-3 px-6 md:px-8 pt-6 pb-4">
              <NumberBadge n="3" />
              <h3 className="text-lg md:text-xl font-bold text-[rgb(2,58,16)]">
                Revenue and Your Share{' '}
                <span className="text-sm font-medium text-gray-400">— Tap Scenario</span>
              </h3>
            </div>

            {/* Scenario Tabs — segmented control */}
            <div className="px-6 md:px-8 pb-5">
              <div className="flex gap-1.5 rounded-full bg-gray-100 p-1.5">
                {scenarios.map((s) => (
                  <button
                    key={s.key}
                    onClick={() => setActiveScenario(s.key)}
                    className={`flex-1 py-2.5 rounded-full text-sm font-semibold transition-all duration-200 ${
                      activeScenario === s.key
                        ? 'bg-gradient-to-r from-[rgb(2,58,16)] to-green-700 text-white shadow-md'
                        : 'text-gray-600 hover:text-[rgb(2,58,16)]'
                    }`}
                  >
                    {s.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Scenario Content */}
            <div className="px-6 md:px-8 pb-8">
              <p className="text-sm text-gray-500 font-serif mb-4">
                {current.label} — {'₹'}{current.pricePerKg}/kg
              </p>

              {/* Revenue Breakdown */}
              <div className="bg-[#fdfaf6] border border-amber-100 rounded-xl p-5 mb-6">
                <div className="space-y-3">
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-600 font-serif">Yelakki farm gate price</span>
                    <span className="font-semibold text-gray-800">
                      {'₹'}{current.pricePerKg} / kg
                    </span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-600 font-serif">Gross revenue (10,000 kg)</span>
                    <span className="font-semibold text-gray-800">
                      {'₹'}{current.grossRevenue}
                    </span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-600 font-serif">Less: production cost</span>
                    <span className="font-semibold text-red-500">
                      − {'₹'}{current.productionCost}
                    </span>
                  </div>
                  <div className="flex justify-between text-sm pt-3 border-t border-amber-200">
                    <span className="text-gray-700 font-serif font-medium">Net proceeds (1st cycle)</span>
                    <span className="font-bold text-[rgb(2,58,16)]">
                      {'₹'}{current.netProceeds}
                    </span>
                  </div>
                </div>
              </div>

              {/* Harvest Share Across Cycles */}
              <div className="mb-6">
                <h4 className="text-sm font-semibold text-gray-700 mb-4">
                  Your harvest share across cycles
                </h4>

                {/* Cycle 1 */}
                <div className="mb-4">
                  <div className="flex items-center mb-1.5">
                    <span className="text-xs font-semibold text-gray-500 w-20">Cycle 1</span>
                    <div className="flex-1">
                      <div className="text-xs text-gray-500 font-serif mb-1">
                        Revenue {'₹'}{current.cycle1.revenue}
                      </div>
                      <div className="w-full bg-gray-100 rounded-full h-6 relative overflow-hidden">
                        <motion.div
                          className="h-full rounded-full bg-gradient-to-r from-[#f5d4a0] to-[#eec583] flex items-center px-3"
                          initial={{ width: 0 }}
                          whileInView={{ width: '50%' }}
                          transition={{ duration: 0.6 }}
                          viewport={{ once: true }}
                        >
                          <span className="text-xs font-medium text-gray-700 whitespace-nowrap">
                            Your 50% → {'₹'}{current.cycle1.yourShare}
                          </span>
                        </motion.div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Cycle 2 & 3 */}
                <div className="mb-4">
                  <div className="flex items-center mb-1.5">
                    <span className="text-xs font-semibold text-gray-500 w-20">Cycle 2 & 3</span>
                    <div className="flex-1">
                      <div className="text-xs text-gray-500 font-serif mb-1">
                        Revenue {'₹'}{current.cycle23.revenue}
                      </div>
                      <div className="w-full bg-gray-100 rounded-full h-6 relative overflow-hidden">
                        <motion.div
                          className="h-full rounded-full bg-gradient-to-r from-[#f0c078] to-[#e6b063] flex items-center px-3"
                          initial={{ width: 0 }}
                          whileInView={{ width: '65%' }}
                          transition={{ duration: 0.6, delay: 0.1 }}
                          viewport={{ once: true }}
                        >
                          <span className="text-xs font-medium text-gray-700 whitespace-nowrap">
                            {current.cycle23.label}
                          </span>
                        </motion.div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Total */}
              <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-100 rounded-xl p-5 flex items-center justify-between">
                <span className="text-sm font-semibold text-gray-700 flex items-center gap-2">
                  <span className="text-green-600">
                    <BarsIcon className="w-5 h-5" />
                  </span>
                  Total over 3 cycles · your share
                </span>
                <span className="text-xl font-bold text-[rgb(2,58,16)]">
                  {'₹'}{current.totalShare}{' '}
                  <span className="text-sm font-normal text-gray-500">({current.totalPercent})</span>
                </span>
              </div>
            </div>
          </motion.div>

          {/* 4. Tax Relief on Harvest Share */}
          <motion.div
            className={cardClass}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <div className="flex items-center gap-3 px-6 md:px-8 pt-6 pb-4">
              <NumberBadge n="4" />
              <h3 className="text-lg md:text-xl font-bold text-[rgb(2,58,16)]">Tax Relief on Harvest Share</h3>
            </div>
            <div className="px-6 md:px-8 pb-6">
              <div className="bg-[#f0faf4] border border-green-100 rounded-xl p-5">
                <div className="flex items-center gap-3 mb-4">
                  <span className="flex-shrink-0 w-10 h-10 text-[rgb(2,58,16)]">
                    <ShieldPercent className="w-10 h-10" />
                  </span>
                  <span className="inline-flex items-center gap-1.5 bg-green-100 text-green-800 text-xs font-bold px-3 py-1 rounded-full">
                    Tax-free income
                  </span>
                </div>
                <div className="space-y-1">
                  <div className="flex items-center justify-between py-2.5 border-b border-green-100">
                    <span className="text-sm text-gray-700 font-serif">Section 10(2A)</span>
                    <span className="flex items-center gap-2 text-sm font-semibold text-green-700">
                      Partner profit share exempt
                      <CheckCircle className="w-5 h-5 flex-shrink-0" />
                    </span>
                  </div>
                  <div className="flex items-center justify-between py-2.5">
                    <span className="text-sm text-gray-700 font-serif">Section 10(1)</span>
                    <span className="flex items-center gap-2 text-sm font-semibold text-green-700">
                      Agricultural income exempt
                      <CheckCircle className="w-5 h-5 flex-shrink-0" />
                    </span>
                  </div>
                </div>
                <p className="text-xs text-gray-500 font-serif mt-4 italic">
                  *Terms apply. Consult your CA for individual advice.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Footer disclaimer with farm scene */}
          <motion.div
            className="relative overflow-hidden bg-gradient-to-br from-green-50 to-emerald-50 border border-green-100 rounded-2xl px-6 py-5"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.35 }}
            viewport={{ once: true }}
          >
            <FarmScene className="absolute bottom-0 right-0 w-56 h-20 opacity-40 pointer-events-none" />
            <div className="relative flex items-start gap-3">
              <span className="flex-shrink-0 w-9 h-9 rounded-full bg-green-100 flex items-center justify-center text-green-600">
                <LeafIcon className="w-5 h-5" />
              </span>
              <p className="text-xs text-gray-500 font-serif leading-relaxed">
                10,000 kg yield/cycle · 50% partner share of net proceeds · cycle 2&3 assume no repeat infrastructure cost
                <br />
                Actual proceeds vary by yield &amp; market price · pure agriculture, not a financial product
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Economics;
